import React, { createContext } from 'react';
import { envConfigs } from './config';
export const ConfigContext = createContext(null);
ConfigContext.displayName = 'ConfigContext';
function ConfigProvider({ children, env, }) {
    if (!envConfigs.hasOwnProperty(env)) {
        throw new Error(`Property env: ${env} is not defined in envConfigs!`);
    }
    return (React.createElement(ConfigContext.Provider, { value: envConfigs[env] }, children));
}
function useConfig() {
    const context = React.useContext(ConfigContext);
    if (context === undefined) {
        throw new Error('useConfig must be used within a ConfigContext');
    }
    return context;
}
export { ConfigProvider, useConfig };
//# sourceMappingURL=ConfigProvider.js.map